import { Breakpoints, styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import { animated } from 'react-spring';
import { useBreakpointIsReached } from './use-breakpoint-is-reached';
import { SlideSpring } from './use-slider-springs';

export interface TrimSelectionColumnProps {
  readonly index: number;
  readonly bindGestureHandlers?: () => React.DOMAttributes<HTMLElement>;
  readonly spring?: SlideSpring;
  readonly onFocusInvisible?: () => void;
  readonly children: JSX.Element;
}

const StyledCell = styled(animated.div)<{ index: number }>`
  padding-left: ${(props) => props.theme.size.grid001};
  will-change: transform;
`;

const StyledImageCell = styled(StyledCell)<{ index: number }>`
  grid-area: ${(props) => `image-${props.index}`};
`;

const StyledImagePlaceholder = styled.div<{ imageRatio: number }>`
  padding-bottom: ${(props) => props.theme.size.static250};
  position: relative;
  padding-top: ${(props) => (1 / props.imageRatio) * 100}%;
`;

const StyledImageWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
`;

const StyledEfficiencyCell = styled(StyledCell)<{ index: number }>`
  padding-bottom: ${(props) => props.theme.size.static300};
  grid-area: ${(props) => `efficiency-${props.index}`};
`;

const StyledTitleCell = styled(StyledCell)<{ index: number }>`
  padding-bottom: ${(props) => props.theme.size.static300};
  grid-area: ${(props) => `title-${props.index}`};
`;

const StyledSloganWrapper = styled.div`
  margin-top: ${(props) => props.theme.size.static100};
`;

const StyledPriceCell = styled(StyledCell)<{ index: number }>`
  padding-bottom: ${(props) => props.theme.size.static350};
  grid-area: ${(props) => `prices-${props.index}`};
`;

const StyledButtonsCell = styled(StyledCell)<{ index: number }>`
  padding-bottom: ${(props) => props.theme.size.static500};
  display: flex;
  align-items: start;
  flex-direction: column;
  word-break: break-word;
  grid-area: ${(props) => `buttons-${props.index}`};
  > :not(:first-child) {
    margin-top: ${(props) => props.theme.size.static200};
  }
`;

const StyledHighlightFeaturesHeadlineCell = styled(StyledCell)<{
  index: number;
}>`
  grid-area: ${(props) => `highlightFeaturesHeadline-${props.index}`};
  padding-bottom: ${(props) => props.theme.size.static350};
  display: flex;
  align-items: flex-end;
`;

const StyledHighlightFeaturesHeadlineWrapper = styled.div`
  padding-bottom: ${(props) => props.theme.size.static200};
  border-bottom: 1px solid ${(props) => props.theme.border.color.secondary};
  width: 100%;
`;

const StyledHighlightFeaturesCell = styled(StyledCell)<{ index: number }>`
  grid-area: ${(props) => `highlightFeatures-${props.index}`};
`;

const StyledStandardEquipmentCtaWrapper = styled.div`
  margin-top: ${(props) => props.theme.size.static350};
  padding-bottom: 10px;
`;

function getCellOpacityStyle(opacity: number, minimumOpacity: number): number {
  return (opacity + minimumOpacity) / (minimumOpacity + 1);
}

function getCellTransformStyle(x: number): string {
  return `translate3d(${x * -1}px,0,0)`;
}

export function TrimSelectionColumn({
  children,
  bindGestureHandlers,
  spring,
  index,
  onFocusInvisible,
}: TrimSelectionColumnProps): JSX.Element {
  const minimumOpacity = useBreakpointIsReached(Breakpoints.b560) ? 0.2 : 0;

  const cellStyle: React.CSSProperties | undefined = spring && {
    opacity: spring.opacity.interpolate((opacity) => getCellOpacityStyle(opacity, minimumOpacity)),
    transform: spring.x.interpolate(getCellTransformStyle),
    pointerEvents: spring.pointerEvents,
  };

  const commonCellProps: React.HTMLAttributes<HTMLDivElement> = {
    ...(bindGestureHandlers && bindGestureHandlers()),
    style: cellStyle,
    onMouseDown: (event) => event.stopPropagation(),
    onFocus: () => {
      if (spring && spring.opacity.getValue() < 1) {
        onFocusInvisible?.();
      }
    },
  };
  return (
    <StyledImageCell index={index} {...commonCellProps}>
      {children}
    </StyledImageCell>
  );
  return (
    <>
      {/* <StyledImageCell index={index} {...commonCellProps}>
        <StyledImagePlaceholder imageRatio={imageRatio}>
          {image && <StyledImageWrapper>{image}</StyledImageWrapper>}
        </StyledImagePlaceholder>
      </StyledImageCell>
      {efficiencies && (
        <StyledEfficiencyCell index={index} {...commonCellProps}>
          {efficiencies}
        </StyledEfficiencyCell>
      )}
      <StyledTitleCell index={index} {...commonCellProps}>
        <VerticalSpacer gap="static100">
          {trimName}
          {slogan && <StyledSloganWrapper>{slogan}</StyledSloganWrapper>}
        </VerticalSpacer>
      </StyledTitleCell>
      {prices && (
        <StyledPriceCell index={index} {...commonCellProps}>
          {prices}
        </StyledPriceCell>
      )}
      <StyledButtonsCell index={index} {...commonCellProps}>
        {buttons}
      </StyledButtonsCell>
      {highlightFeaturesHeadline && (
        <StyledHighlightFeaturesHeadlineCell index={index} {...commonCellProps}>
          <StyledHighlightFeaturesHeadlineWrapper>{highlightFeaturesHeadline}</StyledHighlightFeaturesHeadlineWrapper>
        </StyledHighlightFeaturesHeadlineCell>
      )}
      {highlightFeatures && (
        <StyledHighlightFeaturesCell index={index} {...commonCellProps}>
          {highlightFeatures}
          {standardEquipmentCta && (
            <StyledStandardEquipmentCtaWrapper>{standardEquipmentCta}</StyledStandardEquipmentCtaWrapper>
          )}
        </StyledHighlightFeaturesCell>
      )} */}
    </>
  );
}
